/**
 * Centralized query keys for yard-related TanStack Query queries.
 * Used for cache invalidation and query deduplication.
 */
export const yardQueryKeys = {
  all: ['yard'] as const,

  // Spots
  spots: () => [...yardQueryKeys.all, 'spots'] as const,
  spotsList: (warehouseId: string) => [...yardQueryKeys.spots(), 'list', warehouseId] as const,

  spot: (spotId: string) => [...yardQueryKeys.all, 'spot', spotId] as const,
  spotDetail: (spotId: string) => [...yardQueryKeys.spot(spotId), 'detail'] as const,
  spotSummary: (spotId: string) => [...yardQueryKeys.spot(spotId), 'summary'] as const,
  spotEvents: (spotId: string) => [...yardQueryKeys.spot(spotId), 'events'] as const,

  // Spot Assignments
  spotAssignments: (spotId: string) => [...yardQueryKeys.spot(spotId), 'assignments'] as const,
  spotAssignment: (assignmentId: string) =>
    [...yardQueryKeys.all, 'spotAssignment', assignmentId] as const,

  // Asset Visits
  assetVisits: () => [...yardQueryKeys.all, 'assetVisits'] as const,
  assetVisitsList: (warehouseId: string) =>
    [...yardQueryKeys.assetVisits(), 'list', warehouseId] as const,
  assetVisit: (visitId: string) => [...yardQueryKeys.assetVisits(), visitId] as const,

  // Asset Containers
  assetContainers: () => [...yardQueryKeys.all, 'assetContainers'] as const,
  assetContainer: (containerId: string) =>
    [...yardQueryKeys.assetContainers(), containerId] as const,

  // Yard Tasks
  task: (taskId: string) => [...yardQueryKeys.all, 'task', taskId] as const,

  // Appointments
  appointment: (appointmentId: string) =>
    [...yardQueryKeys.all, 'appointment', appointmentId] as const,

  // Spot Areas (Yard Areas)
  spotAreas: () => [...yardQueryKeys.all, 'spotAreas'] as const,
  spotAreasList: (warehouseId: string) =>
    [...yardQueryKeys.spotAreas(), 'list', warehouseId] as const,
  spotArea: (areaId: string) => [...yardQueryKeys.all, 'spotArea', areaId] as const,
  spotAreaDetail: (areaId: string) => [...yardQueryKeys.spotArea(areaId), 'detail'] as const,

  // BFF View endpoints (pre-computed, flat data for specific views)
  bff: () => [...yardQueryKeys.all, 'bff'] as const,
  listViewRows: (warehouseId: string, includeWaiting = true) =>
    [...yardQueryKeys.bff(), 'listViewRows', warehouseId, includeWaiting] as const,
  spotGrid: (warehouseId: string) => [...yardQueryKeys.bff(), 'spotGrid', warehouseId] as const
} as const;
